import type {PublicMethodUtils} from '@wix/document-services-types'

export default function (publicMethodUtils: PublicMethodUtils) {
    const {
        extensionPublicAPI: {getter, immediate}
    } = publicMethodUtils

    return {
        methods: {
            editorFeatures: {
                instances: {
                    list: immediate('editorFeatures.instances.list'),
                    create: immediate('editorFeatures.instances.create')
                },
                data: {
                    getPointer: getter('editorFeatures.data.getPointer'),
                    listPointers: getter('editorFeatures.data.listPointers'),
                    get: immediate('editorFeatures.data.get'),
                    remove: immediate('editorFeatures.data.remove'),
                    update: immediate('editorFeatures.data.update')
                }
            }
        }
    }
}
